export { CommonEmployeePageTemplate } from './common-page';
